import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import ItemDetail from "./components/ItemDetail"
import OldUIContext from "../../olduicontext"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (element: HTMLElement | undefined | null): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <OldUIContext.Consumer>
                        {(): JSX.Element => <ItemDetail />}
                    </OldUIContext.Consumer>
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        start,
    }
}

export default init
